
import Vue from 'vue'
import { authAxios } from '../utils'
import { Component } from 'vue-property-decorator'

import LoginForm from '../components/LoginForm.vue'
import TwoFactorSetup from '../components/TwoFactorSetup.vue'
import TwoFactorLogin from '../components/TwoFactorLogin.vue'
import TermsConfirmation from '../components/TermsConfirmation.vue'

interface LoginResult {
  success: boolean;
  twoFactorEnabled: boolean;
  acceptedTerms: boolean;
}

@Component({
  components: { LoginForm, TermsConfirmation, TwoFactorLogin, TwoFactorSetup }
})
export default class LoginPage extends Vue {
  error = ''

  step: 'form' | '2fa' | '2fa-setup' | 'terms' = 'form'

  async submit(details: { email: string; password: string }) {
    try {
      const response = await authAxios.post<LoginResult>('/login', { email: details.email, password: details.password, type: 'agency' })
      const result = response.data

      if (result.twoFactorEnabled) {
        await this.$store.dispatch('auth/refresh')
        this.step = '2fa'
      } else {
        this.step = '2fa-setup'
      }
    } catch (error: any) {
      if (error.response.status === 401 && error.response.data && error.response.data.message) {
        this.error = error.response.data.message
      } else {
        this.error = 'Login Failed'
      }
    }
  }

  async completed2FA() {
    if (this.$store.state.acceptedTerms) {
      this.completeLogin()
    } else {
      this.step = 'terms'
    }
  }

  async completeLogin() {
    const path: string = this.$route.query.redirect as string || '/dashboard'
    const query = { ...this.$route.query }
    delete query.redirect
    delete query.hash
    await this.$store.dispatch('auth/refresh')
    this.$router.push({ path, query })
  }

  forgotPassword() {
    this.$router.push({ name: 'forgot-password' })
  }
}
